import { Accordion as AccordionComponent } from '~/_shared/baseComponents/accordion/baseComponents/accordion.component';
import { AccordionItem } from '~/_shared/baseComponents/accordion/baseComponents/accordionItem.component';
import { AccordionItemHeading } from '~/_shared/baseComponents/accordion/baseComponents/accordionItemHeading.component';
import { AccordionPanel } from '~/_shared/baseComponents/accordion/baseComponents/accordionPanel.component';
import { AccordionStepNumber } from '~/_shared/baseComponents/accordion/baseComponents/accordionStepNumber.component';

const accordionComposition = {
  Item: AccordionItem,
  Panel: AccordionPanel,
  ItemHeading: AccordionItemHeading,
  StepNumber: AccordionStepNumber,
} as const;

export const Accordion = Object.assign(AccordionComponent, accordionComposition);

export * from './accordion.component';
export * from './accordion.types';
export {
  ACCORDION_HEADER_SIZE_LARGE, ACCORDION_HEADER_SIZE_MEDIUM,
} from './baseComponents/accordionItemHeading.component';
export * from './useSections';
